import { genTestID } from '@utils/utils';
import { Radio, RadioGroupProps } from 'antd';

interface TaggedRadioProps extends RadioGroupProps{
  tag:string;
  options:Inputs.SelectOption[];
}

const TaggedRadio = (props:TaggedRadioProps) => {
  const { tag, options } = props;

  return (
    <Radio.Group {...props} data-testid={genTestID('radio', tag)}>
      {options.map((option) => (
        <Radio value={option.value}>{option.label}</Radio>
      ))}
    </Radio.Group>
  );
};

export default TaggedRadio;
